import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import AccountLinkForm from '../../../../form/AccountLinkForm';
import AsyncActionButton from '../../../../button/AsyncActionButton';
import FieldSet from '../../../../fieldset/FieldSet';
import VerticalLabelList from '../../../../label/VerticalLabelList';

class STLRealEstateDetailedAccount extends React.Component {
  constructor(props) {
    super(props);

    const { account, } = props;

    this.keyExclusions = [ 'mongoId', 'className', 'extraData', 'autopayTemplateId', ];

    this.state = {
      account,
      isLoading: false,
    };
  }

  STLREALESTATE = 'stl_real_estate';

  sendBillRequest() {
    const { account, } = this.state;
    const { billsMethod, } = this.props;
    this.setState({ isLoading: true, }, () => {
      billsMethod(account.externalAccountId);
      this.setState({ isLoading: false, });
    });
  }

  render() {
    const { isLoading, } = this.state;
    const { account, isModal, } = this.props;

    const items = VerticalLabelList.toList(account, {
      displayFormatter: (value) => {
        const formattedValue = value.split('_').join(' ');
        return _.startCase(formattedValue);
      },
    });
    return (
      <>
        <FieldSet title="Account Summary" style={{ height: '100%', fontSize: '20px', }}>
          <VerticalLabelList items={items} exclusions={this.keyExclusions} />
        </FieldSet>
        {isModal ? null : (
          <div className="p-2">
            <AsyncActionButton
              onClick={() => this.sendBillRequest()}
              contents="Show Bills"
              isLoading={isLoading}
              variant="success"
              loadingVariant="secondary"
            />
            <div className="ps-2" style={{ display: 'inline-block', }}>
              <AccountLinkForm
                id={account.id}
                serviceOfferingId={this.STLREALESTATE}
                customerIds={account.customerIds}
              />
            </div>
          </div>
        )}
      </>
    );
  }
}

STLRealEstateDetailedAccount.defaultProps = {
  billsMethod: () => {},
};

STLRealEstateDetailedAccount.propTypes = {
  account: PropTypes.instanceOf(Object).isRequired,
  isModal: PropTypes.bool.isRequired,
  billsMethod: PropTypes.func,
};

export default STLRealEstateDetailedAccount;
